import React from "react";
import { PoweredByQgiv } from "@qgiv/core-react";
import "./AccountModalFooter.scss";

const AccountModalFooter = () => (
    <div className="account-modal-footer">
        <PoweredByQgiv dark />
    </div>
);

export default AccountModalFooter;
